import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { MessagesService } from '../messages/messages.service';
import { Plate, SourcePlate } from '../models/plate';
import { Comment } from '../models/comment';
import { BeadChipStatus, PlateStatus, ProcessStep, ProcessUpdateStage } from '../models/process-step';
import { Sample } from '../models/sample';
import { SampleCommentDTO } from '../models/sampleCommentDTO';
import { Step } from '../models/step';
import { ErrorHandler } from '../utils/error-handler';
import { MaResultEvaluationService } from './ma-result-evaluation.service';
import { TableHeaders } from './model/headers-dto';
import { CircleColors, CompleteBeadchipAndSourcePlatesDTO, EvaluationComparators, PlateUpdateDTO, ReportingFileNameDTO, SingleSamplesRedoDTO } from './model/ma-result-evaluation-dtos';
import { SingleRedoFileResponse, SingleRedoMultiPlateRequestDTO, SingleRedoSampleObject } from './model/upload-single-redo-file-response-dto';
import { priorityMap } from '../utils/priority-row';
import { RedoType } from '../models/redo-type-enum';
import { MergeSourcePlatesDTO, PlateUpdateInfo } from '../ma-plate-preparation/multiplate-update-dto';
import { WorkFlow } from '../masterdata/models/workFlow';
import { ProcessUpdateDTO, SampleData } from '../models/wb-process-update';
import { SampleRedoDTO, SampleWithAnalysisType } from '../models/sampleRedoDTO';
import { AnalysisType } from '../models/analysis-type';


const NO_REDO_OPERATION_REDO_TYPES: Array<string> = [RedoType.NO_REDO, RedoType.MERGE_REDO];

@Component({
	selector: 'app-ma-result-evaluation',
	templateUrl: './ma-result-evaluation.component.html',
	styleUrls: ['./ma-result-evaluation.component.css']
})
export class MaResultEvaluationComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;

  @Input() isResultEvaluationSelectedFromSamplesComponent: boolean = false;
  @Input() scannedPlateID: string = null;
  @Input() selectedPlateType: string = null;

  blocked = false;
  selectedLabId: string;
  selectedWorkFlow: WorkFlow;
  puid: string;
  loading: boolean;
  filterOptions: any[];
  selectedStatuses: string[] = [];
  statusFilterList: string[] = [BeadChipStatus.WAITING_FOR_ANALYSIS, BeadChipStatus.WASH_AND_STAIN_PREP, BeadChipStatus.ANALYSIS_STARTED];
  selectedProcessFlowList: string[] = [];
  processFlows: ProcessFlow[] = []
  processFlowsList = [];
  fromDate: Date = new Date();
  processFlowMap: Map<string, ProcessFlow> = new Map();
  missingBarcodesInCellFile: string[] = [];

  @ViewChild('arrayOutputFile')
  arrayOutputFileElement: ElementRef;
  uploadedFile: File;
  uploadedFileContent: any;
  isFileNotSelected: boolean = true;

  reportingFileName: string = "";

  tableSelectedRow :Plate;
  plates: Plate[] = [];
  selectedPlate: Plate = new Plate();
  selectedPlateStepsMap: Map<string, Step> = new Map();
  plateToSearch: string;
  sampleToSearch: string;

  plateMap: Map<string, Sample> = new Map();
  map = new Map<string, string>();
  circleBorder: string = "black";
  circleStroke: string = "3";

  headers = new TableHeaders();

  samplePopUpVisible = false;
  selectedSample: Sample = new Sample();
  sampleComments: any[];
  commentView: boolean = false;
  newComment: string = '';
  sampleHoverVisible: boolean = false;

  passColor: string = CircleColors.GREEN;
  checkColor: string = CircleColors.YELLOW;
  failColor: string = CircleColors.RED;

  callRateColor1: string = CircleColors.YELLOW;
  callRateColor2: string = "#99D9EA";
  callRateColor3: string = CircleColors.RED;

  qcCallRateColor1: string = "#b5e61d";
  qcCallRateColor2: string = "#ffaec9";
  qcCallRateColor3: string = "#a349a4";

  dqcColor1: string = "#880015";
  dqcColor2: string = CircleColors.GREY;
  dqcColor3: string = "#3f48cc";

  callRateCutoff1: number = 90;
  callRateCutoff2: number = 0;
  callRateCutoff3: number = 0;

  qcCallRateCutoff1: number = 0;
  qcCallRateCutoff2: number = 0;
  qcCallRateCutoff3: number = 0;

  dqcCutoff1: number = 0;
  dqcCutoff2: number = 0;
  dqcCutoff3: number = 0;

  selectedValueForComparision: string= EvaluationComparators.CALL_RATE

  plate1Color: string = "blue";
  plate2Color: string = "#59d13b";
  plate3Color: string = CircleColors.FFC90E;
  plate4Color: string = "#ec4319";

  isSampleSelectionMode: boolean = false;
  selectedSamplesMap: Map<string, Sample> = new Map();

  @ViewChild('fileUploaderRedoSamples')
  redoSamplesUploadElement: any;

  sampleRedoConfirmationVisible: boolean = false;
  multipleSampleRedoConfirmationVisible: boolean = false;
  completeAnalysisConfirmationVisible: boolean = false;
  multipleSampleRedoList: Array<SingleRedoSampleObject> = [];

  hairRedoList = [
    {label:"Report",value: {"redoLabel":"Report","redo":RedoType.NO_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""}},
    {label:"Lysis Redo",value: {"redoLabel":"Lysis Redo","redo":RedoType.LYSIS_REDO,"status":PlateStatus.PLATE_REDO,"stepName":"","sampleType":"Hair"}},
    {label:"Extraction Redo",value: {"redoLabel":"Extraction Redo","redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_STARTED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Hair"}},
    {label:"Aliquotation Redo",value: {"redoLabel":"Aliquotation Redo","redo":RedoType.ALIQUOTATION_REDO,"status":PlateStatus.EXTRACTION_COMPLETED,"stepName":ProcessStep.ALIQUOTATION,"sampleType":"Hair"}}
  ]
  eartagRedoList = [
    {label:"Report",value: {"redoLabel":"Report","redo":RedoType.NO_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""}},
    {label:"Extraction Redo",value: {"redoLabel":"Extraction Redo","redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_COMPLETED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Eartag"}},
    {label:"Aliquotation Redo",value: {"redoLabel":"Aliquotation Redo","redo":RedoType.ALIQUOTATION_REDO,"status":PlateStatus.EXTRACTION_COMPLETED,"stepName":ProcessStep.ALIQUOTATION,"sampleType":"Eartag"}}
  ]
  tlrRedoList = [
    {label:"Report",value: {"redoLabel":"Report","redo":RedoType.NO_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""}},
    {label:"Aliquotation Redo",value: {"redoLabel":"Aliquotation Redo","redo":RedoType.ALIQUOTATION_REDO,"status":PlateStatus.EXTRACTION_COMPLETED,"stepName":ProcessStep.ALIQUOTATION,"sampleType":"TLR"}}
  ]

  mergeRedoList = [
    {label:"Report",value: {"redoLabel":"Report","redo":RedoType.NO_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""}},
    {label:"Merge Redo",value: {"redoLabel":"Merge Redo","redo":RedoType.MERGE_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""}}
  ]

  noRedoList = [
    {label:"Report",value: {"redoLabel":"Report","redo":RedoType.NO_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""}}
  ]

  dnaOFHOKTRedoList = [{label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.LYSIS , status: PlateStatus.RECEIVED}}];

  dnaICBFOKTRedoList = [{label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.LYSIS , status: PlateStatus.RECEPTION_COMPLETED}}];

  dnaOFHTLRRedoList = [{label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.EXTRACTION , status: PlateStatus.RECEIVED}}];

  dnaICBFTLRRedoList = [{label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.EXTRACTION , status: PlateStatus.RECEPTION_COMPLETED}}];

  dnaOFHQCRedoList = [{label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.QC_SCAN , status: PlateStatus.RECEIVED}}];

  dnaICBFQCRedoList = [{label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.QC_SCAN , status: PlateStatus.RECEPTION_COMPLETED}}];

  selectedRedoTypes: any[] = [];
  plateSampleTypes: Array<Set<string>> = [];

  //Comments Variables
  fetchedCommentsPlate: Plate = new Plate();
  selectedPlateID: string = "";
  selectedPlateStatus: string = "";
  plateCommentsList: Comment[]=[];
  showCommentDialog: boolean = false;
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  selectedPlateSourcePlateIdList: Array<string> = [];
  isProcessUpdateProxied:boolean

  selectedArraySourceMergePlateSourcePlates: Map<string, Array<SourcePlate>> = new Map();
  mergeRedoSourcePlates: Map<string, Array<SourcePlate>> = new Map();
  mergePlateSourcePlateRedoOptions: Map<string, Array<any>> = new Map()
  mergePlateSourcePlateRedoSelection: Map<string, Array<any>> = new Map()
  popUpWithRedoForMergePlate: boolean = false;

  showDueDate = false;

  constructor(private masterDataService: MasterDataService, private _messagesService: MessagesService,
    private announcementService:AnnouncedService, private resultEvaluationService: MaResultEvaluationService,
    private platePreparationService: MaPlatePreparationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedWorkFlow = JSON.parse(localStorage.getItem('selectedWorkFlow'));
    const isDateRange = JSON.parse(localStorage.getItem('lab')).lab.dateRange;
    this.isProcessUpdateProxied = this.selectedWorkFlow.proxyWeatherbyAPI

    this.getAllProcessFlows()
    this.filterOptions = [
      { label: 'Waiting For Analysis', value: BeadChipStatus.WAITING_FOR_ANALYSIS },
      { label: 'Analysis Started', value: BeadChipStatus.ANALYSIS_STARTED },
      { label: 'Delivered', value: BeadChipStatus.DELIVERED },
      { label: 'Redo', value: BeadChipStatus.REDO },
      { label: 'Plate Redo', value: BeadChipStatus.PLATE_REDO }
    ];
    this.mapSamplesAndPositions();
    this.updateSourcePlateRedoTypeList();
    if (isDateRange) {
      this.fromDate.setDate(new Date().getDate() - 5);
    } else {
      this.fromDate.setDate(new Date().getDate() - 31);
    }
    this.fetchArrays(undefined, undefined, this.fromDate);

    this.activatedRoute.queryParams.subscribe(params=>{
      let plateID: string = params['plateID']
      if(plateID && plateID.trim()!==''){
        this.plateToSearch = plateID;
        this.searchForPlate()
      }
    });

    if(this.scannedPlateID) {
      this.plateToSearch = this.scannedPlateID;
      this.searchForPlate();
      this.scannedPlateID = null;
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  onApplyFilter(){
    let queryStatusList = this.selectedStatuses.join(',');
    let queryWorkFlowList = this.selectedProcessFlowList.join(',');
    this.fetchArrays(queryStatusList, queryWorkFlowList, this.fromDate);
  }

  resetAllFilter(){
    this.selectedStatuses = [];
    this.selectedProcessFlowList = [];
    this.fromDate = undefined;
    this.fetchArrays();
  }

  mapSamplesAndPositions() {
    this.plateMap.clear();
    this.selectedPlate.samples = this.selectedPlate.samples ? this.selectedPlate.samples : []
    if(this.selectedPlate.samples.length>0){
      this.selectedPlate.samples.forEach(sample => {
        this.plateMap.set(sample.position, sample)
        this.updatePlateSampleTypesList(sample);
      })
    }
  }

  updateSourcePlateRedoTypeList(){
    this.selectedRedoTypes = [];
    this.plateSampleTypes = [];
    this.selectedPlateSourcePlateIdList = [];
    if(this.selectedPlate.sourcePlates){
      this.selectedPlate.sourcePlates.forEach(plate => {
        this.selectedRedoTypes.push({"redoLabel":"Report","redo":RedoType.NO_REDO,"status":PlateStatus.COMPLETED,"stepName":"","sampleType":""});
        this.plateSampleTypes.push(new Set());
        this.selectedPlateSourcePlateIdList.push(plate.lastUpdatedPlateID);
      })
    }
  }

  fetchArrays(status?: string, workFlow?: string, fromDate?: Date) {
    if(status === '' || status == undefined){
      status = this.statusFilterList.join(',');
    }
    if(workFlow === ''){
      workFlow = undefined;
    }
    this.loading = true;
    this.resultEvaluationService.fetchArrays(this.selectedLabId, status, workFlow, fromDate).subscribe({
     next : (result) => {
        this.loading = false;
        this.plates = result["data"];
        this.highlightSelectedPlateInTable();
      },
      error: (error: any) => {
        this.loading = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }})
  }

  highlightSelectedPlateInTable(){
    if(!this.selectedPlate.plateID){
      return;
    }
    for(let i=0; i<this.plates.length; i++){
      if(this.selectedPlate.plateID == this.plates[i].plateID){
        this.tableSelectedRow = this.plates[i]
        break
      }
    }
  }

  getAllProcessFlows() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe({
      next: results => {
        this.blocked = false;
        if (results && results.data) {
          this.processFlows = results.data;
          this.processFlowsList = [];
          this.processFlowMap.clear();
          this.processFlows.forEach(e => {
            this.processFlowsList.push({ label: e.processFlowName, value: e.processFlowName });
            this.processFlowMap.set(e.processFlowName, e);
          });
        }
      },error : error => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  searchForPlate() {
    if(!this.plateToSearch || this.plateToSearch===''){
      this.removePlateSelection();
      return;
    }
    this.searchForPlateAction(this.plateToSearch);
    this.plateToSearch="";
  }

  searchForPlateAction(plateID: string){
    this.blocked = true;
    this.resultEvaluationService.fetchArray(plateID,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedPlate = result.data;
        this.reportingFileName = this.selectedPlate.reportingFileName;
        this.updateSourcePlateRedoTypeList();
        this.fetchMergePlateSourcePlates();
        this.prepareProcessStepsMap();
        this.mapSamplesAndPositions();
        this.highlightSelectedPlateInTable();
        this.isSampleSelectionMode = false;
      }, error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error["bbApiError"]["message"]
        })
      }
    })
  }

  fetchMergePlateSourcePlates() {
    this.selectedArraySourceMergePlateSourcePlates.clear();
    let dto = new MergeSourcePlatesDTO();
    dto.labId = this.selectedLabId;
    dto.plateIDs = this.selectedPlateSourcePlateIdList;
    this.platePreparationService.fetchMergePlateSourcePlates(dto).subscribe({
      next : (result) => {
        Object.keys(result.data).forEach( (key) => {
          if(result.data[key].length!=0)
            this.selectedArraySourceMergePlateSourcePlates.set(key, result.data[key]);
        })
      },
      error: (error: any) => {
        this._messagesService.addSuccessMessage({
          severity:'error', detail: error.error.bbApiError.message
        })
      }
    })
  }

  prepareProcessStepsMap() {
    this.selectedPlateStepsMap.clear();

    if(!this.selectedPlate.processSteps)
      return;

    this.selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(item => {
        step.actionMap.set(item.action, item);
      })
      this.selectedPlateStepsMap.set(step.step, step);
      }
    )
  }

  removePlateSelection(){
    this.selectedPlateStepsMap.clear();
    this.selectedPlate = new Plate();
    this.selectedRedoTypes = [];
    this.plateMap.clear();
    this.reportingFileName = "";
    this.selectedArraySourceMergePlateSourcePlates.clear();
    this.mergePlateSourcePlateRedoOptions.clear();
    this.mergePlateSourcePlateRedoSelection.clear();
  }

  searchForSample() {
    if (!this.sampleToSearch || this.sampleToSearch === '') {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId, this.sampleToSearch).subscribe({next : (result) => {
      let sample = result.data[0]
      let sample_id = sample['_id']
      this.resultEvaluationService.fetchArrayBySample(sample_id, this.selectedLabId).subscribe({
        next : (result) => {
          this.blocked = false
          this._messagesService.addSuccessMessage({
            severity: 'success', detail: 'Sample search success!'
          })
          this.selectedPlate = result.data;
          this.reportingFileName = this.selectedPlate.reportingFileName;
          this.updateSourcePlateRedoTypeList();
          this.prepareProcessStepsMap();
          this.mapSamplesAndPositions();
          this.highlightSelectedPlateInTable();
          this.isSampleSelectionMode = false;
          this.sampleToSearch = "";
        }, error: (error: any) => {
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to fetch plate info',
            detail: error.error["bbApiError"]["message"]
          })
        }
      })
    }, error: (error: any) => {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Failed to fetch plate info',
        detail: error.error.error
      })
    }})
  }

  fetchPlate(event) {
    this.searchForPlateAction(event.data.plateID);
  }

  get384Position(row: number, col: number) {
    return '' + this.headers.rowHeaders384[row] + this.headers.columnHeaders384[col]
  }

  showSamplePopUp(row:string, col: number) {
    let position = row + col;
    if (!this.plateMap.has(position)) {
      return;
    }

    this.selectedSample = this.plateMap.get(position)
    this.selectedSample.sourcePlatePosition = this.getSourcePosition(this.selectedSample.position);
    this.platePreparationService.getSampleComments(this.selectedLabId, this.selectedSample._id).subscribe(res => {
      if (res.data) {
        this.sampleComments = res.data
      }
    })
    this.samplePopUpVisible = true;
  }

  getSourcePosition(position: string){
    let row96:string, col96:string, rowVal96:number, colVal96:number;

    row96 = position[0]
    rowVal96 = this.headers.rowHeaders384.indexOf(row96)
    rowVal96 = rowVal96 == 0 ? rowVal96 : rowVal96 - 1

    col96 = position.slice(1,)
    colVal96 = this.headers.columnHeaders384.indexOf(Number(col96))
    colVal96 = colVal96 == 0 ? colVal96 : colVal96 - 1
    return this.convert384To96Index(rowVal96, colVal96)
  }

  convert384To96Index(rowVal, colVal) {
    if (rowVal % 2 == 0 && colVal % 2 == 0) {
      return this.convert384PositionTo96Position(rowVal, colVal, 0, 0, 2)
    }
    else if (rowVal % 2 != 0 && colVal % 2 == 0) {
      return this.convert384PositionTo96Position(rowVal, colVal, 1, 0, 2)
    }
    else if (rowVal % 2 == 0 && colVal % 2 != 0) {
      return this.convert384PositionTo96Position(rowVal, colVal, 0, 1, 2)
    }
    else if (rowVal % 2 != 0 && colVal % 2 != 0) {
      return this.convert384PositionTo96Position(rowVal, colVal, 1, 1, 2)
    }
  }

  getPosition96(row:number, col:number) {
    return '' + this.headers.rowHeaders[row] + this.headers.columnHeaders[col];
  }

  convert384PositionTo96Position(rowVal, colVal, rowAdder: number, colAdder: number, divider: number) {
    let posRow = (rowVal + rowAdder) / divider;
    let posCol = (colVal + colAdder) / divider;
    return this.getPosition96(posRow, posCol);
  }

  getQuadrant(row: number, col: number) {
    let position = this.get384Position(row, col);
    if (!this.plateMap.has(position)) {
      return "white";
    }

    if (row % 2 == 0 && col % 2 == 0) {
      //plate1
      return this.plate1Color;
    }
    else if (row % 2 == 0 && col % 2 != 0) {
      //plate2
      return this.plate2Color;
    }
    else if (row % 2 != 0 && col % 2 == 0) {
      //plate3
      return this.plate3Color;
    }
    else{
      //plate4
      return this.plate4Color;
    }
  }

  getPlateBorderClass(index:number){
    return "plate-border-"+(index+1)
  }

  onFileSelect(filesData) {
    if (filesData.target.files.length > 0) {
      const file = filesData.target.files[0];
      this.uploadedFile = file;
      this.isFileNotSelected = false;
    } else {
      this.isFileNotSelected = true;
    }
  }

  uploadArrayOutputFile(fileInput: HTMLInputElement){
    const formData = new FormData();
    formData.append('file', this.uploadedFile);
    formData.append('labID', this.selectedLabId);
    formData.append('puid', this.puid)
    this.blocked = true;
    this.resultEvaluationService.uploadArrayOutputFile(formData).subscribe({
      next: result => {
        this.blocked = false;
        fileInput.value = null;
        if (!result) {
          return;
        }
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful', detail: 'Array Output file has been uploaded successfully' });
        this.selectedPlate = result.data;
        this.reportingFileName = this.selectedPlate.reportingFileName;
        this.selectedValueForComparision = EvaluationComparators.CALL_RATE;
        this.updateSourcePlateRedoTypeList();
        this.prepareProcessStepsMap();
        this.mapSamplesAndPositions();
        this.onApplyFilter();
        this.isFileNotSelected = true;
        this.arrayOutputFileElement.nativeElement.value = "";
      },
      error: error => {
        this.blocked = false;
        fileInput.value = null;
        this.isFileNotSelected = true;
        this.arrayOutputFileElement.nativeElement.value = "";
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })
  }

  getSampleCircleFillColor(row:string, col: number){
    let position = row + col;
    if(!this.plateMap.get(position)){
      return CircleColors.WHITE
    }

    let sample = this.plateMap.get(position);
    if(this.selectedValueForComparision==""){
      return CircleColors.WHITE
    }

    let comparator = this.selectedValueForComparision;
    let value = sample[comparator];
    if(!value){
      return CircleColors.GREY
    }

    if(sample[comparator] >= this[comparator+"Cutoff1"]){
      return this.passColor;
    }
    else if(sample[comparator] < this[comparator+"Cutoff1"] && sample[comparator] >= this[comparator+"Cutoff2"]){
      return this.checkColor;
    }
    else if(sample[comparator] < this[comparator+"Cutoff2"] && sample[comparator] >= this[comparator+"Cutoff3"]){
      return this.failColor;
    }
    else{
      return CircleColors.WHITE
    }
  }

  isCrossRequired(row:string, col: number){
    let position = row+col;
    if(!this.plateMap.has(position)){
      return false
    }

    let sample = this.plateMap.get(position);
    return !(sample["presentInCellFile"] && sample["gender"] == sample["computedGender"])
  }

  isBoxRequired(row:string, col: number){
    let position = row+col;
    if(!this.plateMap.has(position)){
      return false
    }

    let sample = this.plateMap.get(position);
    return (sample["presentInCellFile"] && sample["gender"] != sample["computedGender"])
  }

  getCrossColor(row:string, col: number){
    let position = row + col;
    if(!this.plateMap.has(position)){
      return CircleColors.RED
    }

    let sample = this.plateMap.get(position);
    if(!sample["presentInCellFile"]){
      return CircleColors.RED
    }
    else if(sample["gender"] != sample["computedGender"]){
      return CircleColors.LIGHT_GREY
    }
    else{
      return CircleColors.RED
    }
  }

  isAutoReRun(row:string, col: number){
    let position = row + col;
    if(!this.plateMap.has(position)){
      return CircleColors.WHITE
    }

    let sample = this.plateMap.get(position);
    if(sample["autoRerun"]){
      return CircleColors.F06292
    }
    else{
      return CircleColors.WHITE
    }
  }

  updateSelectedValueForComparision(val: string){
    this.selectedValueForComparision = val;
  }

  updateReportingFileName(){
    let data = new ReportingFileNameDTO();
    data.plateID = this.selectedPlate.plateID;
    data.labID = this.selectedLabId
    data.reportingFileName = this.reportingFileName;
    this.blocked = true;
    this.resultEvaluationService.updateReportingFileName(data).subscribe({
      next: _result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Saved Successful', detail: 'Reporting File Name has been saved successfully!!' });
      },
      error: error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })
  }

  disableSaveFileName(){
    return this.selectedPlate.plateID == undefined;
  }

  disableCompleteAnalysisButton(){
    return !this.selectedPlate.plateID? true : this.selectedPlate.status != BeadChipStatus.ANALYSIS_STARTED
  }

  disableStartSampleRedoButton(){
    return !this.selectedPlate.plateID? true : (this.selectedPlate.status != BeadChipStatus.ANALYSIS_STARTED) || (this.selectedSamplesMap.size == 0)
  }

  getNewArrayStatus() {
    let redoCount: number = 0;
    this.selectedPlate.sourcePlates.forEach(sourcePlate => {
      if (sourcePlate.redoType && sourcePlate.redoType != RedoType.NO_REDO) {
        if (sourcePlate.redoType != RedoType.MERGE_REDO) {
          redoCount++
        } else {
          let redoSelections = this.mergePlateSourcePlateRedoSelection.get(sourcePlate.plateID);
          let partialRedo = false
          redoSelections.forEach((redoSelection) => {
            partialRedo = partialRedo || redoSelection.redo == RedoType.NO_REDO;
          })
          if(!partialRedo){
            redoCount++;
          }
        }
      }
    })

    return redoCount === this.selectedPlate.sourcePlates.length ? BeadChipStatus.REDO : BeadChipStatus.DELIVERED;
  }

  createPlateListData(completeData: Array<any>, redoData: Array<any>, sourcePlateList: Array<any>, mergeSourcePlateRedoList: Array<any>){
    this.selectedPlate.sourcePlates.forEach( (sourcePlate, index) => {
      sourcePlateList.push(sourcePlate.lastUpdatedPlateID);

      let redoType = this.selectedRedoTypes[index]
      if(redoType.redo && !NO_REDO_OPERATION_REDO_TYPES.includes(redoType.redo)){
        let plateUpdateInfo = new PlateUpdateInfo();
        plateUpdateInfo.plateID = sourcePlate.plateID;
        plateUpdateInfo.lastUpdatedPlateID = sourcePlate.lastUpdatedPlateID;
        plateUpdateInfo.redoLabel = redoType.redoLabel;
        plateUpdateInfo.redo = redoType.redo;
        plateUpdateInfo.status = redoType.status;
        plateUpdateInfo.sampleType = redoType.sampleType;
        plateUpdateInfo.stepName = redoType.stepName;
        redoData.push(plateUpdateInfo)
      }
      else if(redoType.redo &&  RedoType.MERGE_REDO == redoType.redo){
        let completeSourcePlate = false;
        this.mergePlateSourcePlateRedoSelection.get(sourcePlate.plateID).forEach( (val, sub_index) => {
          if(RedoType.NO_REDO == val.redo){
            completeSourcePlate = true;
          }
          else{
            let plateUpdateInfo = new PlateUpdateInfo();
            plateUpdateInfo.plateID = this.mergeRedoSourcePlates.get(sourcePlate.plateID)[sub_index].plateID;
            plateUpdateInfo.lastUpdatedPlateID = this.mergeRedoSourcePlates.get(sourcePlate.plateID)[sub_index].lastUpdatedPlateID;
            plateUpdateInfo.redoLabel = val.redoLabel;
            plateUpdateInfo.redo = val.redo;
            plateUpdateInfo.status = val.status;
            plateUpdateInfo.sampleType = val.sampleType;
            plateUpdateInfo.stepName = val.stepName;
            redoData.push(plateUpdateInfo);
            mergeSourcePlateRedoList.push(plateUpdateInfo.lastUpdatedPlateID);
          }
        })

        if(completeSourcePlate){
          completeData.push(sourcePlate.lastUpdatedPlateID);
        }else{
          let plateUpdateInfo = new PlateUpdateInfo();
          plateUpdateInfo.plateID = sourcePlate.plateID;
          plateUpdateInfo.lastUpdatedPlateID = sourcePlate.lastUpdatedPlateID;
          plateUpdateInfo.redoLabel = "Merge Redo";
          plateUpdateInfo.redo = RedoType.NO_REDO;
          plateUpdateInfo.status = PlateStatus.PLATE_REDO;
          plateUpdateInfo.sampleType = sourcePlate.sampleType;
          plateUpdateInfo.stepName = "ANALYSIS";
          redoData.push(plateUpdateInfo);
        }
      }
      else{
        completeData.push(sourcePlate.lastUpdatedPlateID);
      }
    })
  }

  createDataForPlateUpdate(){
    const plateUpdateDTO = new PlateUpdateDTO();
    plateUpdateDTO.labID = this.selectedLabId;
    plateUpdateDTO.plateID = this.selectedPlate.plateID;
    plateUpdateDTO.status = this.getNewArrayStatus();
    plateUpdateDTO.stepName = "ANALYSIS";
    plateUpdateDTO.puid = this.puid;
    return plateUpdateDTO;
  }

  completeAnalysis(){
    if(!this.selectedPlate.plateID || this.selectedPlate.plateID===""){
      return;
    }
    this.completeAnalysisConfirmationVisible = false;
    const plateUpdateDTO = this.createDataForPlateUpdate();
    this.blocked = true;
    this.resultEvaluationService.completeAnalysis(plateUpdateDTO).subscribe({
      next: analysis_result=>{
        this.blocked = false;

        this._messagesService.addSuccessMessage({
          severity:"success", summary:"Array Updated!",
          detail:`Array ${this.selectedPlate.plateID} successfully delivered!`
        })
        const data = this.generateDataForPlateCompletion();
        this.mergeRedoSourcePlates.clear();
        let singleSampleRedoDetails = new SampleRedoDTO();
        singleSampleRedoDetails.analysisType = true;
        singleSampleRedoDetails.reRunCount = true;
        singleSampleRedoDetails.sampleIdList = data.singleRedoSamples.map(sample => {
          const sampleWithAnalysisType = new SampleWithAnalysisType()
          sampleWithAnalysisType.sampleID = sample
          sampleWithAnalysisType.type = AnalysisType.INTERNAL_RERUN
          return sampleWithAnalysisType
        });
        const plateSampleRedoDetails = new SampleRedoDTO();
        plateSampleRedoDetails.analysisType = true;
        plateSampleRedoDetails.reRunCount = false;
        plateSampleRedoDetails.sampleIdList = data.plateRedoSamples.map(sample => {
          const sampleWithAnalysisType = new SampleWithAnalysisType()
          sampleWithAnalysisType.sampleID = sample
          sampleWithAnalysisType.type = AnalysisType.INTERNAL_RERUN
          return sampleWithAnalysisType
        });
        this.blocked = true;
        this.platePreparationService.completeBeadchipAndSourcePlates(data).subscribe({
          next: result => {
            this.selectedPlate  = analysis_result.data;
            this.blocked = false;
            this.performProcessUpdateForWeatherby(this.selectedPlate);
            this.updateCompletionForSamples(data.deliveredSamples);
            this.announcementService.updateRedoSample(this.selectedLabId, singleSampleRedoDetails).subscribe(
              _result=>{
                this._messagesService.addSuccessMessage({
                  severity:'success',summary:"Success!", detail: result
                })
              }
            )
            this.announcementService.updateRedoSample(this.selectedLabId, plateSampleRedoDetails).subscribe(
              _result=>{
                this._messagesService.addSuccessMessage({
                  severity:'success',summary:"Success!", detail: result
                })
              }
            )
          },
          error: error => {
            this.blocked = false;
            this._messagesService.addSuccessMessage({
              severity:'error', detail: error.error
            })
          }
        })
        this.onApplyFilter();
      },
      error: _error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error', summary:"Error Occurred!",
          detail:"Error occurred while completing analysis of the array!"
        })
      }
    });
  }

  performProcessUpdateForWeatherby(arrayPlate:Plate){
    let weatherbySampleDataList = arrayPlate.samples.map<SampleData>(sample => {
      let sampleData : SampleData = {
        sampleId:sample._id,
        description: "",
        status : ProcessUpdateStage.COMPLETED
      }
      if((sample.singleRedo || sample.plateRedo) && sample.autoRerun && sample.callRate < 90 && sample.reRunCount == 0){
        sampleData.status = ProcessUpdateStage.AUTO_RETEST
      }
      else if((sample.singleRedo || sample.plateRedo)){
        sampleData.status = ProcessUpdateStage.RETEST
      }
      sampleData.description = arrayPlate.reportingFileName || ""
      return sampleData
    })

    let weatherByProcessUpdateDto : ProcessUpdateDTO = {
      data :  weatherbySampleDataList,
      labId : this.selectedLabId
    }
    this.announcementService.weatherbyProcessUpdate(weatherByProcessUpdateDto,this.isProcessUpdateProxied).subscribe({
      next: _result => {},
      error: _error => {
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:'Something went wrong while sending an ProcessUpdate event to weatherbys'
        })
      }
    })
  }

  updateCompletionForSamples(sampleIds: string[]){
    if(sampleIds.length == 0){
      return;
    }
    let request = {};
    request['labId'] = this.selectedLabId;
    request['sampleIds'] = sampleIds;
    request['puid'] = this.puid;
    this.blocked = true;
    this.platePreparationService.updateOFHCompletedSamples(request).subscribe({
      next: (_result)=>{
        this.blocked = false;
      },
      error: (error) => {
          this.blocked = false;
          this.showError(error);
        }
    })
  }

  generateDataForPlateCompletion(){
    let plateCompleteList = [];
    let plateRedoList = [];
    let sourcePlateList = [];
    let mergeSourcePlateRedoList = [];
    this.createPlateListData(plateCompleteList, plateRedoList, sourcePlateList, mergeSourcePlateRedoList);

    let data = new CompleteBeadchipAndSourcePlatesDTO();
    data.labID = this.selectedLabId;
    data.arrayID = this.selectedPlate.plateID;
    data.sourcePlateIDs = sourcePlateList;
    data.plateCompleteList = plateCompleteList;
    data.mergeSourcePlateRedoList = mergeSourcePlateRedoList;
    let result = this.getSingleRedoSamples(this.selectedPlate.samples);
    data.singleRedoSamples = result['singleRedoSamples'];
    data.deliveredSamples = result['deliveredSamples'];
    data.plateRedoSamples = result['plateRedoSamples'];
    data.plateRedoList = plateRedoList;
    data.puid = this.puid;

    return data;
  }

  getSingleRedoSamples(samples: Array<Sample>): {}{
    let singleRedoSamplesObjectId = [];
    let deliveredSamples = [];
    let plateRedoSamples = []
    samples.forEach( sample => {
      if(sample.plateRedo){
        plateRedoSamples.push(sample._id);
      }
      if(sample.singleRedo){
        singleRedoSamplesObjectId.push(sample._id);
      }else if(!sample.singleRedo && !sample.plateRedo){
        deliveredSamples.push(sample._id);
      }
    })
    let result = {};
    result['singleRedoSamples'] = singleRedoSamplesObjectId;
    result['deliveredSamples'] = deliveredSamples;
    result['plateRedoSamples'] = plateRedoSamples;
    return result;
  }

  closeSamplePopup(){
    this.selectedSample = new Sample();
    this.samplePopUpVisible = false;
    this.sampleComments = [];
    this.newComment = "";
  }

  disableAddComment(){
    return this.newComment.trim() == "";
  }

  toggleCommentView() {
    this.commentView = !this.commentView
  }

  getCommentDTO(){
    let newComment = new SampleCommentDTO;
    newComment.puid = this.puid;
    newComment.status = this.selectedPlate.status;
    newComment.comment = this.newComment;
    return newComment;
  }

  addCommentToSample(){
	let commentObject = this.getCommentDTO();
	this.blocked = true;
    this.announcementService.updateSampleComment(this.selectedLabId, this.selectedSample._id, commentObject).subscribe({
      next : (result) =>{
        this.blocked = false;
        commentObject.timeStamp = new Date(new Date().toISOString());
        this.sampleComments.push(commentObject);
        this.newComment = "";
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result.data })
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  isSampleSelected(row:string, col: number){
    return this.isSampleSelectionMode && this.selectedSamplesMap.has(row+col)
  }

  startSampleSelectionForRedo(){
    this.isSampleSelectionMode = true;
    this.selectedPlate.samples.forEach( (sample) => {
      if((sample.singleRedo || (sample.autoRerun && sample.callRate<90 && sample.reRunCount==0)) && sample.presentInCellFile){
        this.selectedSamplesMap.set(sample.position, sample);
      }
    })
  }

  startSampleRedo(){
    let singleSamplesRedoData = new SingleSamplesRedoDTO();
    singleSamplesRedoData.plateID = this.selectedPlate.plateID;
    singleSamplesRedoData.labID = this.selectedLabId
    singleSamplesRedoData.redoPositions = Array.from(this.selectedSamplesMap.keys());

    this.blocked = true;
    this.resultEvaluationService.updateSingleRedoSamples(singleSamplesRedoData).subscribe({
      next: _result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Redo Started', detail: 'Selected samples are marked as single redo!!' });
        this.isSampleSelectionMode = false;
        this.selectedPlate.samples.forEach( (s) => {
          let sample = this.plateMap.get(s.position);
          if(this.selectedSamplesMap.has(s.position)){
            sample.singleRedo = true;
          }else{
            sample.singleRedo = false;
          }
          this.plateMap.set(s.position, sample);
        })
        this.selectedSamplesMap.clear();
      },
      error: error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })
  }

  exitSampleRedo(){
    this.isSampleSelectionMode = false;
    this.selectedSamplesMap.clear();
  }

  clickSample(row:string, col: number){
    if(!this.isSampleSelectionMode){
      this.showSamplePopUp(row, col);
    }else{
      this.selectSampleForRedo(row, col);
    }
  }

  selectSampleForRedo(row:string, col: number){
    let samplePosition = row+col;

    if(this.selectedSamplesMap.has(samplePosition)){
      this.selectedSamplesMap.delete(samplePosition);
      return;
    }

    if(!this.plateMap.has(samplePosition)){
      return;
    }

    let currentSample:Sample = this.plateMap.get(samplePosition);
    if(currentSample.plateRedo){
      this._messagesService.addWarningMessage({
        severity:'warn', summary:'Cannot Redo Sample',
        detail:`Sample ${currentSample.sampleID} is already on plate redo!!`
      })
      return;
    }

    if(currentSample.reRunCount >= 1){
      this.selectedSample = currentSample;
      this.sampleRedoConfirmationVisible = true;
      return;
    }

    this.selectedSamplesMap.set(samplePosition, this.plateMap.get(samplePosition))
  }

  onRedoFileSelect(event){
    if(!(event.files[0].type === "text/csv")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only .csv files are allowed.'
      });
    }
    this.exitSampleRedo();
    this.selectedPlate = new Plate();
    this.tableSelectedRow = null;
  }

  uploadSingleRedoFile(event){
    const formData = new FormData();
    formData.append('file', event.files[0]);
    formData.append('labID', this.selectedLabId);

    this.blocked = true;
    this.resultEvaluationService.uploadSingleRedoFile(formData).subscribe({
      next : (result) => {
        this.blocked = false;
        this.redoSamplesUploadElement.clear();
        let data: SingleRedoFileResponse = result.data;
        if (data.samplesUpdated) {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'File Uploaded!',
            detail: data.message
          })
        } else {
          this._messagesService.addSuccessMessage({
            severity: 'warn', summary: 'File Uploaded!',
            detail: data.message
          })
        }
        if(data.confirmationSamplesList.length!=0){
          this.multipleSampleRedoList = data.confirmationSamplesList;
          this.multipleSampleRedoConfirmationVisible = true;
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.redoSamplesUploadElement.clear();
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Error',
          detail: error.error["bbApiError"]["message"]
        })
      }
    });
  }
  checkForMissingSamplesInCelFile(){
    return this.missingBarcodesInCellFile.length > 0;
  }

  toggleCompleteAnalysisConfirmationPopUp(){
    let isPlateMergeRedos = false;
    this.mergeRedoSourcePlates.clear();
    this.selectedPlate.sourcePlates.forEach( sourcePlate => {
      isPlateMergeRedos = isPlateMergeRedos || sourcePlate.redoType == RedoType.MERGE_REDO
      if(sourcePlate.redoType == RedoType.MERGE_REDO){
        this.mergeRedoSourcePlates.set(sourcePlate.plateID, this.selectedArraySourceMergePlateSourcePlates.get(sourcePlate.plateID));
      }

    })

    if(isPlateMergeRedos){
      this.showPopUpForMergePlateRedo();
      return;
    }

    if(this.completeAnalysisConfirmationVisible == false){
      this.missingBarcodesInCellFile = [];
      this.selectedPlate.samples.filter(sample=>sample.presentInCellFile==false).map(sample=> this.missingBarcodesInCellFile.push(sample.sampleID))
    }
    this.completeAnalysisConfirmationVisible = !this.completeAnalysisConfirmationVisible;
  }

  closeSampleRedoConfirmationPopUp(){
    this.selectedSample = new Sample();
    this.sampleRedoConfirmationVisible = false;
  }

  sampleRedoConfirmation(){
    this.selectedSamplesMap.set(this.selectedSample.position, this.selectedSample)
    this.closeSampleRedoConfirmationPopUp();
  }

  closeMultipleSampleRedoConfirmationPopUp(){
    this.multipleSampleRedoConfirmationVisible = false;
    this.multipleSampleRedoList = [];
  }

  multipleSampleRedoConfirmation(){
    let singleRedoMultiPlateRequestData = new SingleRedoMultiPlateRequestDTO();
    singleRedoMultiPlateRequestData.confirmationSamplesList = this.multipleSampleRedoList;
    singleRedoMultiPlateRequestData.labID = this.selectedLabId
    singleRedoMultiPlateRequestData.ignoreReRunCount = true

    this.blocked = true;
    this.resultEvaluationService.updateMultiPlateSingleRedoSamples(singleRedoMultiPlateRequestData).subscribe({
      next: _result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Redo Started', detail: 'Selected samples are marked as single redo!!' });
        this.closeMultipleSampleRedoConfirmationPopUp();
      },
      error:error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })
  }

  getPriorityClass(priority:number){
    return priorityMap[priority]
  }

  getPlateRedoList(processFlowName: string, index: number){
    if(!processFlowName){
      this.updateSourcePlateRedoValue(this.noRedoList, index)
      return this.noRedoList;
    }

    if(this.selectedArraySourceMergePlateSourcePlates.has(this.selectedPlate.sourcePlates[index].plateID) &&
      this.selectedArraySourceMergePlateSourcePlates.get(this.selectedPlate.sourcePlates[index].plateID).length != 0){
        this.updateSourcePlateRedoValue(this.mergeRedoList, index);
        return this.mergeRedoList;
      }

    let redoList = this.getRedoList(processFlowName);
    this.updateSourcePlateRedoValue(redoList, index)
    return redoList;
  }

  getRedoList(processFlowName: string){
    let redoList;
    let plateProcessFlow: ProcessFlow = this.processFlowMap.get(processFlowName);
    if(plateProcessFlow.okTOpureHair){
      redoList = this.hairRedoList;
    }else if(plateProcessFlow.okTOpureEartag){
      redoList = this.eartagRedoList;
    }else if(plateProcessFlow.ExEartagTLR){
      redoList = this.tlrRedoList;
    }else{
      redoList = this.noRedoList;
    }

    return this.getRedoListForDNAPlates(plateProcessFlow, redoList);
  }

  private getRedoListForDNAPlates(plateProcessFlow: ProcessFlow, redoList: Array<any>) {
    if (this.selectedPlate.sampleType != "DNA") {
      return redoList;
    }

    if (plateProcessFlow.qcScan) {
      if (this.selectedPlate.workFlow == "ICBF") {
        return redoList.concat(this.dnaICBFQCRedoList);
      }

      return redoList.concat(this.dnaOFHQCRedoList);
    }
    else if (plateProcessFlow.okTOpureEartag || plateProcessFlow.okTOpureHair) {
      if (this.selectedPlate.workFlow == "ICBF") {
        return redoList.concat(this.dnaICBFOKTRedoList);
      }

      return redoList.concat(this.dnaOFHOKTRedoList);
    } else if (plateProcessFlow.ExEartagTLR) {
      if (this.selectedPlate.workFlow == "ICBF") {
        return redoList.concat(this.dnaICBFTLRRedoList);
      }

      return redoList.concat(this.dnaOFHTLRRedoList);
    }

    return redoList;
  }

  updateSourcePlateRedoValue(redoList:any[], index){
    let sourcePlateRedoType = this.selectedPlate.sourcePlates[index].redoType;
    redoList.forEach( redoType => {
      if(sourcePlateRedoType == redoType["value"]["redo"]){
        this.selectedRedoTypes[index] = redoType["value"];
      }
    });
  };

  updatePlateRedoValue(event, sourcePlateIndex){
    const redoTypeValue = event.value;
    const sourcePlate: SourcePlate = this.selectedPlate.sourcePlates[sourcePlateIndex];
    sourcePlate.redoType = redoTypeValue["redo"];
    sourcePlate.status = redoTypeValue["status"];
    sourcePlate.redoSampleType = redoTypeValue["sampleType"];
    if(this.selectedArraySourceMergePlateSourcePlates.has(sourcePlate.lastUpdatedPlateID)){
        sourcePlate.sourcePlateIDs = this.selectedArraySourceMergePlateSourcePlates.get(sourcePlate.lastUpdatedPlateID).map(sourcePlate => sourcePlate.plateID);
    }

    this.blocked = true;
    this.resultEvaluationService.updatePlateRedo(this.selectedLabId, this.selectedPlate.plateID, sourcePlate).subscribe({
      next:_result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity:"success", summary:"Plate Redo Updated!!"
        })
        this.selectedPlate.samples.forEach((sample) => {
          if(this.getPlateIndexFrom384Position(sample.position) == sourcePlateIndex){
            if(sourcePlate.redoType == "NO_REDO"){
              sample.plateRedo = false;
            }else{
              sample.plateRedo = true;
            }
            this.plateMap.set(sample.position, sample);
          }
        })
      },
      error: error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  getLegendColor(comparator: string, colorType: string){
    return this.selectedValueForComparision !== comparator ? CircleColors.GREY : this[colorType+"Color"];
  }

  getButtonColor(comparator: string){
    return this.selectedValueForComparision !== comparator ? "call-rate-label" : "call-rate-label-selected";
  }

  isRedoSample(row, col){
    let position = row+col;
    if(!this.plateMap.has(position)){
      return false
    }

    let sample = this.plateMap.get(position);
    return sample["reRunCount"]? sample["reRunCount"]!=0 : false;
  }

  getPlateSampleTypes(index: number){
    return Array.from(this.plateSampleTypes[index]).join(", ");
  }

  getPlateIndexFrom384Position(position: string){
    let row = this.headers.rowHeaders384.indexOf(position.charAt(0))
    let col = this.headers.columnHeaders384.indexOf(Number(position.slice(1)))

    if (row % 2 == 0 && col % 2 == 0) {
      //plate1
      return 0;
    }
    else if (row % 2 == 0 && col % 2 != 0) {
      //plate2
      return 1;
    }
    else if (row % 2 != 0 && col % 2 == 0) {
      //plate3
      return 2;
    }
    else{
      //plate4
      return 3;
    }
  }

  updatePlateSampleTypesList(sample: Sample){
    let plateIndexFromPosition = this.getPlateIndexFrom384Position(sample.position);
    if(sample.assignedSampleType){
      this.plateSampleTypes[plateIndexFromPosition].add(sample.assignedSampleType);
    }
  }

  showComments(sourcePlateID: string){
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId,sourcePlateID).subscribe({
      next:(result)=>{
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedPlateStatus = this.selectedPlate.status;
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        this.showCommentDialog = true;
      },
      error:(error)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })
  }

  hideDialog(reloadPlateData: boolean = false){
    if(reloadPlateData){
      this.searchForPlateAction(this.selectedPlate.lastUpdatedPlateID)
    }
    this.showCommentDialog = false;
  }

  showPopUpForMergePlateRedo(){
    this.mergeRedoSourcePlates.forEach((value, key) => {
      let mergePlateList = [];
      let selectionList = [];
      value.forEach( sourcePlate => {
        mergePlateList.push(this.getRedoList(sourcePlate.processFlowName));
        selectionList.push({})
      })
      this.mergePlateSourcePlateRedoSelection.set(key, selectionList);
      this.mergePlateSourcePlateRedoOptions.set(key, mergePlateList);
    })
    this.popUpWithRedoForMergePlate = true;
  }

  disableUpdateMultiRedoForMergedPlatesButton(){
    let disable = false;

    this.mergePlateSourcePlateRedoSelection.forEach( values => {
      values.forEach(redoSelection => {
        if(Object.keys(redoSelection).length == 0){
          disable = true;
        }
      })
    })

    return disable;
  }

  updateMultiRedoForMergedPlates(){
    let mergeSourcePlateRedoPlateID = [];
    this.mergeRedoSourcePlates.forEach((sourcePlates, key) => {
      let redoSelections = this.mergePlateSourcePlateRedoSelection.get(key);
      redoSelections.forEach( (redoSelection, index) => {
        if(redoSelection.redo != RedoType.NO_REDO){
          mergeSourcePlateRedoPlateID.push(sourcePlates[index].lastUpdatedPlateID)
        }
      } )
    })

    this.selectedPlate.samples.forEach( sample => {
      if(mergeSourcePlateRedoPlateID.includes(sample.sourcePlateID)){
        sample.plateRedo = true;
      }
    })

    this.popUpWithRedoForMergePlate = false;

    if(!this.completeAnalysisConfirmationVisible){
      this.missingBarcodesInCellFile = [];
      this.selectedPlate.samples.filter(sample=>!sample.presentInCellFile).map(sample=> this.missingBarcodesInCellFile.push(sample.sampleID))
    }
    this.completeAnalysisConfirmationVisible = !this.completeAnalysisConfirmationVisible;
  }

  convertTimeStampToDate(date){
    if(!date){
      return null
    }
    return new Date(date);
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }
}
